
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.207 2.328a1.121 1.121 0 011.586 1.586l-.993.993-1.616-1.556 1.023-1.023zM10.77 4.766l1.616 1.556-6.897 6.896-2.115.529.529-2.114 6.867-6.867zM14 0c-.828 0-1.622.329-2.207.914L10.05 2.658l-7.757 7.756a1 1 0 00-.263.465l-1 4a1 1 0 001.213 1.213l4-1a1 1 0 00.464-.264l7.813-7.813 1.687-1.687A3.121 3.121 0 0014 0zM1.5 18.5a1 1 0 100 2H16a1 1 0 100-2H1.5z"}})])
          )
        }
      }
    